import './auto-complete.styl';
import AutoComplete from 'antd/lib/auto-complete/index';

export default AutoComplete;
